<template>
    <CardShell>
        <SettingsMenuItem
            :image="require(`@/assets/img/icon_listmytools_step2_information.svg`)"
            title="Account Info"
            route="/account-info"
        />
        <SettingsMenuItem
            :image="require(`@/assets/img/icon_notifications.svg`)"
            title="Notifications"
            route="/notifications"
        />
        <SettingsMenuItem
            :image="require(`@/assets/img/icon_listmytools_step3_rates.svg`)"
            title="Payment"
            route="/error-page"
        />
    </CardShell>

</template>

<script>
import CardShell from '@/components/global/CardShell.vue';
import SettingsMenuItem from '@/components/accountSettings/settingsMenu/SettingsMenuItem.vue';

export default {
    components: {
        CardShell,
        SettingsMenuItem
    }
};
</script>
